// var angular = require('angular');
// var _ = require('lodash');

(function () {
    'use strict';

    angular
        .module('app')
        .service('authService', authService);

    authService.$inject = ['$timeout', '$http', '$sessionStorage', 'apiBaseUrl'];

    function authService($timeout, $http, $sessionStorage, apiUrl) {
        this.authorize = function() {
            return this
                .getInfo()
                .then(function(info) {
                    if (info.authenticated === true)
                        return true;
                    // anonymous
                    throw new softship.helpers.AuthorizationError();
                });
        };

        this.getInfo = function () {
            return $timeout(function() {
                    return $sessionStorage;
                },
                100);
        };

        this.retrieveEnvironment = function () {
            return $http.post(apiUrl + 'api/authenticate/AuthenticationService.asmx/GetEnvironment',
                    { },
                    { responseType: 'json' })
                .then(function (resp) {
                    $sessionStorage.environment = resp.data.d.environment;
                    return;
                });
        };

        this.login = function (userName, password) {
            return $http.post(apiUrl + 'api/authenticate/AuthenticationService.asmx/Authenticate',
                { userName: userName, password: password },
                { responseType: 'json' })
                .then(function (resp) {
                    $sessionStorage.authenticated = resp.data.d.authenticated;

                    // put in session scope
                    $sessionStorage.logonInfo = {
                        username: userName,
                        loggedInSince: resp.data.d.loggedInSince,
                        isAnonymous: resp.data.d.isAnonymousUser,
                        security: resp.data.d.security
                    };
                    return resp.data;
                });
        };

        this.loginUsingTicket = function (ticketId) {
            return $http.post(apiUrl + 'api/authenticate/AuthenticationService.asmx/AuthenticateUsingTicket',
                { ticketId: ticketId },
                { responseType: 'json' })
                .then(function (resp) {
                    $sessionStorage.authenticated = resp.data.d.authenticated;

                    // put in session scope
                    $sessionStorage.logonInfo = {
                        username: resp.data.d.user,
                        loggedInSince: resp.data.d.loggedInSince,
                        isAnonymous: resp.data.d.isAnonymousUser,
                        security: resp.data.d.security
                    };
                    return resp.data;
                });
        };

        this.logout = function () {
            $sessionStorage.authenticated = false;
            $sessionStorage.logonInfo = {};
        };
    }
})();


// WEBPACK FOOTER //
// ./src/services/app.auth.service.js